// i18n area 'common' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.hu-HU.meta.json.
import type { enUS } from './common'

export const huHU: typeof enUS = {
  nav: {
    home: 'Kezdőlap',
    vms: 'Virtuális gépek',
    templates: 'Sablonok',
    importVms: 'VM-ek importálása',
    containers: 'Konténerek',
    containersApps: 'Appok',
    containersPods: 'Podok',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI-image-ek',
    containersOciRegistries: 'OCI-registry-k',
    containersCtTemplates: 'CT-sablonok',
    networkServices: 'Hálózati szolgáltatások',
    firewall: 'Tűzfal',
    checkpoints: 'Checkpointok',
    backup: 'Biztonsági mentés',
    monitoring: 'Monitorozás',
    cluster: 'Klaszter',
    clusterSettings: 'Globális beállítások',
    clusterNodes: 'Csomópontok',
    clusterDevices: 'USB- és PCIe-erőforrások',
    clusterFederation: 'Föderáció',
    network: 'Hálózat',
    overlayNetworks: 'Overlay-hálózatok',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Tároló',
    data: 'Adatok',
    storages: 'Tárolók',
    hci: 'Hiperkonvergencia',
    ceph: 'Ceph',
    system: 'Rendszer',
    tasks: 'Feladatok',
    events: 'Események',
    audit: 'Audit',
    diagnostics: 'Diagnosztika',
    notifications: 'Értesítések',
    proximity: 'TVirt Proximity',
    users: 'Felhasználók és csoportok',
    groups: 'Csoportok',
    mfa: 'MFA',
    realms: 'Realmek és SSO',
    rbac: 'Szerepkörök és engedélyek',
    credentials: 'Hitelesítő adatok',
    scopes: 'Scope-ok',
    tags: 'Címkék',
    explorer: 'Tallózás',
    licensing: 'Licenc',
    information: 'Névjegy'
  },
  mode: {
    light: 'Világos',
    dark: 'Sötét',
    system: 'Rendszer',
    tooltip: 'Téma'
  },
  language: {
    tooltip: 'Nyelv'
  },
  langRegion: {
    europe: 'Európa',
    northAmerica: 'Észak-Amerika',
    southAmerica: 'Dél-Amerika',
    asia: 'Ázsia'
  },
  notFound: {
    title: 'Az oldal nem található',
    body: 'Ez a cím a TVirt egyetlen oldalának sem felel meg — lehet, hogy egy frissítéssel elköltözött, vagy a link régi.',
    backHome: 'Vissza a kezdőlapra'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'A teljes klaszter',
    noChildren: 'Itt nincs al-scope',
    recursive: 'Leszármazottakkal együtt',
    collapse: 'A scope-panel összecsukása',
    openPicker: 'Scope-ok tallózása',
    up: 'Egy szinttel feljebb',
    countTooltip: '{direct} ebben a scope-ban · {total} a leszármazottakkal'
  },
  search: {
    tooltip: 'Keresés (⌘K)',
    placeholder: 'VM-ek, hálózatok, tárolók keresése…',
    empty: 'Nincs találat',

    // Round command palette (#221, ratifica 2026-08-06): intestazioni dei
    // gruppi, i tipi fuori dal censimento explorer, il vocabolario tasti e i
    // verbi del gruppo Azioni.
    groups: {
      recent: 'Legutóbbiak',
      shortcuts: 'Parancsikonok',
      actions: 'Műveletek',
      goTo: 'Ugrás ide'
    },
    kind: {
      catalog: 'Katalógus',
      scope: 'Scope',
      node: 'Csomópont'
    },
    footer: {
      navigate: 'navigálás',
      open: 'megnyitás',
      close: 'bezárás'
    },
    actions: {
      createVm: 'VM létrehozása…',
      uploadIso: 'ISO feltöltése…',
      clusterSettings: 'Klaszterbeállítások',
      consoleOf: 'Ugrás {name} konzoljához'
    }
  },
  stub: {
    containersSummary: 'Alkalmazások és rendszerkonténerek (CT), a hozzájuk tartozó OCI-image-ekkel, registry-kkel és sablonokkal — a VM-jeid mellett kezelve.',
    sectionSummary_vms: 'Virtuális gépek és sablonjaik — életciklus, pillanatképek, migráció és konzol.',
    sectionSummary_storages: 'A tárolók, ahol a VM-ek lemezei, lemezképei és metaadatai élnek.',
    sectionSummary_catalogs: 'A klaszter fájl-artefaktumainak otthona: ISO-lemezképek, CT- és VM-sablonok meg OCI-archívumok, katalógusokba rendezve.',
    sectionSummary_overlay: 'VXLAN overlay-hálózatok a klaszter csomópontjai között.',
    sectionSummary_fabric: 'A fizikai hálózat leltára — switchek, portok, LAGG-ok és logikai hálózatok.',
    sectionSummary_ipam: 'A fabric- és overlay-hálózatokból származtatott címzés: ki birtokolja az egyes címeket.',
    sectionSummary_services: 'A hálózati nyilvántartásból származtatott DHCP- és DNS-szerverek.',
    sectionSummary_ceph: 'A TVirt-csomópontokon kezelt Ceph-klaszterek.',
    sectionSummary_hci: 'Hiperkonvergens tárolótechnológiák a TVirt-csomópontokon.',
    sectionSummary_cluster: 'Csomópontok, tagság és klaszterbeállítások.',
    containers: 'A rendszerkonténerek a roadmapen vannak — ez a terület ad majd nekik helyet.',
    containersApps: 'A konténerizált alkalmazások a roadmapen vannak — ez a terület ad majd nekik helyet.',
    containersPods: 'A podok hálózatot és köteteket megosztó konténereket fognak össze — a példányok az appok.',
    containersCt: 'A rendszerkonténerek (CT) a roadmapen vannak — ez a terület ad majd nekik helyet.',
    multiscsi: 'A TVStor MultiSCSI a roadmapen van — ez a terület ad majd neki helyet.',
    clusterFederation: 'A TVirt-klaszterek közötti föderáció a roadmapen van — ez a terület ad majd neki helyet.',
    containersOciImages: 'Az OCI-image-ek a roadmapen vannak — ez a terület ad majd nekik helyet.',
    containersOciRegistries: 'Az OCI-registry-k a roadmapen vannak — ez a terület ad majd nekik helyet.',
    containersCtTemplates: 'A CT-sablonok a roadmapen vannak — ez a terület ad majd nekik helyet.',
    importVms: 'Ide érkeznek majd az ESXi- és Proxmox-importerek: guestek konvertálása és tömeges migráció a TVirt-be.',
    backup: 'Az integrált biztonsági mentés a 6.2-vel érkezik: deduplikált, content-addressed repository-k, CBT-alapú inkrementális mentések, immutabilitási ablakok és repo-to-repo replikáció.',
    monitoring: 'A klaszterszintű erőforrás-versengési irányítópultok (cpu.ready, PSI-nyomás, beépített riasztások) úton vannak — ma ugyanezek a metrikák az egyes VM-ek részleteiben élnek.'
  },
  home: {
    welcome: 'Ezzel a felhasználóval léptél be: {name}',
    subtitle: 'Íme a TVirt-klasztered egy pillantásra.',
    loadError: 'Az áttekintés nem tölthető be — elérhető a TVirt backend?',
    health: {
      ok: 'Minden rendben',
      warning: 'Figyelmeztetés',
      critical: 'Kritikus problémák'
    },
    reason: {
      'node-down': '{subject} ki van kapcsolva',
      'node-stale': '{subject} egy ideje nem jelentkezik',
      'node-maintenance': '{subject} karbantartás alatt',
      'tasks-failed': {
        one: '{n} sikertelen feladat az elmúlt 24 órában',
        other: '{n} sikertelen feladat az elmúlt 24 órában'
      },
      'storage-degraded': 'a(z) {subject} tároló degradált',
      'storage-error': 'a(z) {subject} tároló hibaállapotban',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'a klaszter store-ja nem érhető el',
      'license-absent': 'nincs licenc — új VM nem indulhat',
      'license-expired': 'a licenc lejárt — új VM nem indulhat',
      'license-exceeded': 'licenckorlát túllépve — új VM nem indulhat',
      'failover-reserve-eroded': 'a failover-tartalék majdnem elfogyott',
      'failover-reserve-exhausted': 'a failover-tartalék kimerült — új VM nem indulhat',

      'oci-cache-nearly-full': 'OCI-gyorsítótár majdnem tele: {subject} — a digesteket kézzel kell eltávolítani',
      'oci-cache-full': 'OCI-gyorsítótár tele: {subject} — amíg nem távolítasz el digesteket, egyetlen pull sem fog sikerülni',
      'config-replica-empty': 'a konfigurációs replika ÜRES itt: {subject} — a csomópontnak nincs fürtkonfigurációja, amíg egy replikáció nem sikerül',
      'config-replica-stalled': 'a konfiguráció replikálása megállt itt: {subject} — a helyi másolat lemarad a fürt konfigurációjától'
    },
    staleChip: 'Nem friss adatok',
    staleAsOf: 'utolsó replika: {time}',
    zone: {
      nodes: 'Csomópontok',
      failoverReserve: 'Failover-tartalék',
      capacity: 'Kapacitás',
      workload: 'Munkaterhelés',
      protection: 'Védelem',
      activity: 'Friss tevékenység'
    },

    // La zona riserva di failover (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'A tartalék ép',
        eroded: 'A tartalék majdnem elfogyott',
        exhausted: 'A tartalék kimerült',
        unknown: 'A tartalék ismeretlen'
      },
      tolerate: {
        one: 'elviseli {n} csomópont elvesztését',
        other: 'elviseli {n} csomópont elvesztését'
      },
      usedOf: '{used} / {allowed} GiB használatban',
      keepFree: '{n} GiB szabadon tartva a failoverhez',
      expendable: 'ebből {n} üzem közben feláldozható',
      headroom: 'még {n} GiB indítható',
      short: 'a tartalékból {n} GiB hiányzik — új VM nem indulhat',

      // Pagine enormi per taglia (ratifica 2026-08-04) — forma «etichetta:
      // {n}» apposta: nessuna lingua deve declinare dopo un numero variabile.
      hp: {
        usedOf: 'Lapméret {size} — használatban: {used} / {allowed}',
        keepFree: 'szabadon tartva a failoverhez: {keep}',
        headroom: 'még indítható: {n}',
        short: 'a tartalékból hiányzik: {n} — új, óriáslapos VM nem indulhat'
      },
      worstCase: 'legrosszabb eset: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Még egyetlen csomópont sem deklarálta a memóriáját — a tartalék nem számítható, és egyetlen indítás sincs elutasítva.',
      reason: {
        attestedDown: 'kikapcsoltnak nyilvánítva',
        maintenance: 'karbantartás alatt',
        unreachable: 'elérhetetlen',
        capacityUnknown: 'memória nincs deklarálva'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} mag / {threads} szál',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktív VM',
        other: '{n} aktív VM'
      },
      activeVmsUnknown: 'Az aktív VM-ek száma ismeretlen',
      lastSeen: 'látva: {time}',
      neverSeen: 'sosem jelentkezett',
      down: 'Kikapcsolva',
      maintenance: 'Karbantartás',
      stale: 'Elérhetetlen'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisionálva',
      reserve: 'tartalék: {n} GiB',
      unobserved: 'a kapacitás még nem megfigyelt',
      empty: 'Még nincs tároló'
    },
    workload: {
      vms: 'Virtuális gépek',
      apps: 'Appok',
      services: 'Hálózati szolgáltatások',
      empty: 'Még semmi',
      phasesUnknown: 'fázisonkénti bontás nem elérhető'
    },
    protection: {
      none: 'Nincs beállított backup-célhely — védd meg a konfigurációdat.',
      configure: 'Checkpointok beállítása',
      noRuns: 'Még egyetlen checkpoint sem készült.',
      last: 'Utolsó checkpoint',
      onTarget: 'célhely: {target}',
      viewAll: 'Checkpointok'
    },
    activity: {
      empty: 'Nincs friss tevékenység',
      failed24: {
        one: '{n} sikertelen 24 órán belül',
        other: '{n} sikertelen 24 órán belül'
      },
      viewAll: 'Összes feladat megtekintése'
    }
  },
  notes: {
    title: 'Jegyzetek',
    tabEdit: 'Szerkesztés',
    tabPreview: 'Előnézet',
    placeholder: 'Az operátor szabad jegyzetei — a Markdown az előnézetben renderelődik',
    empty: 'Nincs jegyzet',
    tooLarge: 'A jegyzetek túllépik a 64 KiB-os korlátot',
    saveError: 'A jegyzetek mentése nem sikerült'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'A backend válasza olyan értéket tartalmaz, amelyet ez a felület nem ismer: {field}={value} — frissítsd a webui-t a backend verziójára.',
    contractErrorItems: 'A lista {count} objektuma nem olvasható ennek a felületnek ({field}={value}), ezért nem jelenik meg.',
    staleHint: 'A store nem érhető el — ez ennek a csomópontnak a konfigurációreplikája; a flotta állapota ismeretlen.',
    staleStateAge: 'állapot: {time}',
    staleStateNever: 'az állapot sosem érkezett meg a store-ból: csak ennek a csomópontnak a saját megfigyeléseit látod',
    staleStateTooltip: 'A fürt store-ja nem érhető el: a megfigyelt állapot (fázis, csomópont, ügynök) ennek a csomópontnak az állapotreplikájából származik, és a store utolsó sikeres olvasásának idejéből való — elavult lehet.',
    noPermission: 'Nincs jogosultságod ehhez a művelethez',

    // Un budget di attesa scaduto NON è un esito (Luca 2026-08-06): il
    // cronometro del client misura la pazienza del client, non lo stato del
    // server — l'avviso dice «ancora in corso», mai «non riuscita».
    actionStillRunning: 'A művelet még folyamatban van: az eredmény még nem ismert',
    staleWrite: 'Valaki más módosította ezt az objektumot, miközben szerkesztette — semmi sem íródott. Töltse újra, és ismételje meg a módosítást a friss állapoton.',
    staleReload: 'Újratöltés',
    preview: 'Előnézet',
    previewTitle: 'Az eredmény előnézete',
    previewNothingWritten: 'A kiszolgálón szimulálva — semmi nem lett kiírva.',
    previewChanged: 'Kiemelve: az értékek, amelyek megváltoznának.'
  },
  context: {
    copySelection: 'Kijelölt szöveg másolása'
  },
  crud: {
    create: 'Létrehozás',
    viewDetails: 'Részletek megtekintése',
    viewOrEdit: 'Megtekintés vagy szerkesztés',
    selected: 'kijelölve',
    viewUsingVms: 'Az erőforrást használó VM-ek megtekintése',
    clearSelection: 'Kijelölés megszüntetése',
    deleteSelected: 'Kijelöltek törlése',
    bulkConfirmBody: {
      one: 'Törlöd a kijelölt {count} elemet? A védettek jelezve lesznek és megmaradnak.',
      other: 'Törlöd a kijelölt {count} elemet? A védettek jelezve lesznek és megmaradnak.'
    },
    bulkDeleted: 'törölve',
    bulkRefused: 'elutasítva',
    fieldId: 'ID',
    createdAt: 'Létrehozva',
    updatedAt: 'Frissítve',
    immutableField: 'A létrehozáskor rögzül — a contract nem engedi módosítani',
    immutableScope: 'A scope a létrehozáskor kerül kiosztásra; egyes erőforrások külön művelettel költöztethetők',
    observedField: 'Megfigyelt állapot — a platform jelenti, nem módosítható'
  }
}
